<script setup lang="ts">
import { ref } from 'vue'
import DolphinTextInput from '@/components/atoms/DolphinTextInput.vue'
import FlatButton from '@/components/atoms/FlatButton.vue'
import { stringifyUserVariableDataType } from '@/features/userVariable/dataType'
import {
  useUpdateUserVariableDefinitionMutation,
  type SettingsPageLineActivationUserVariableEditFormUserVariableDefinitionFragment,
} from './SettingsPageLineActivationUserVariableEditForm.generated'
import { useAlert } from '@/libs/alertPortal'

const props = defineProps<{
  userVariableDefinition: SettingsPageLineActivationUserVariableEditFormUserVariableDefinitionFragment
}>()

const emit = defineEmits<{
  (event: 'changed'): void
}>()

const alert = useAlert()

const form = ref({
  name: props.userVariableDefinition.name,
})

const updateUserVariableDefinitionMutation =
  useUpdateUserVariableDefinitionMutation()

const save = async () => {
  if (form.value.name.length == 0) {
    return
  }

  await updateUserVariableDefinitionMutation.mutate({
    input: {
      guid: props.userVariableDefinition.guid,
      name: form.value.name,
    },
  })

  emit('changed')

  alert.success('カスタム項目を更新しました')
}
</script>

<template>
  <section>
    <div :class="$style.form">
      <div :class="$style.formRow">
        <p :class="$style.label">名前</p>
        <DolphinTextInput :class="$style.textInput" v-model="form.name" />
      </div>
      <div :class="$style.formRow">
        <p :class="$style.label">データ型</p>
        <p>
          {{
            stringifyUserVariableDataType(
              userVariableDefinition.value.__typename
            )
          }}
        </p>
      </div>
    </div>
    <div :class="$style.submit">
      <FlatButton
        :class="$style.submit"
        @click="save"
        :disabled="form.name.length == 0"
      >
        この内容で保存する
      </FlatButton>
    </div>
  </section>
</template>

<style module lang="scss">
.form {
  display: flex;
  flex-direction: column;
  gap: 32px;
}

.formRow {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.label {
  color: $color-text-and-object-high-emphasis;
  font-size: 16px;
  font-weight: bold;
  line-height: 24px;
}

.textInput {
  width: 100%;
}

.submit {
  display: flex;
  margin-top: 16px;
  justify-content: center;
}
</style>
